/*
import * as ht from './_ht_20220706a';

import * as gbl from './_hmGBL_20220707a';

import hlJPz from './_hlJPz_20220707a.json'
import hlENz from './_hlENz_20220707a.json'

const $dz = {
  JP: hlJPz as ht.dz,
  EN: hlENz as ht.dz,
} as ht.dz;

export const setLgg = (pLgg: ht.s) => {
  gbl.set('lgg', { lgg: pLgg })
};

export const t = (
  pEpt: ht.s, // endpoint
//  pLgg?: ht.s // language
) => {
  const _lgg = gbl?.crt('lgg')?.lgg ?? 'EN';
  const [_pDmn, _pWord] = pEpt.split('.');
  return $dz[_lgg][_pDmn][_pWord]
};
*/

import * as hf from './_hf';
import * as ht from './_ht';

//import * as rcl from './_csRcl';

import { useGblz } from './_csGbl';

import { hlJPz } from './_hlJPz'
import { hlENz } from './_hlENz'

const _wordz = {
  JP: hlJPz as ht.dz,
  EN: hlENz as ht.dz,
} as ht.dz;

/*
const _lggz = rcl.grtAtom('lggz', {
  lgg: 'EN',
});
*/
const _gLggz = useGblz('lgg', {
  lgg: 'EN',
});

export const useLggz = () => {
//  const _dz = rcl.grtStt(_lggz);
  const _t = ( // translate
    pEpt: ht.s
  ) => {

    if (!pEpt) return null;

//    let _lgg = _dz.crt.lgg ?? 'EN';
    let _lgg = _gLggz.crt.lgg ?? 'EN';

    const [_dmn, _word, _fmt] = pEpt.split('.');

    let _r = 
      _wordz[_lgg] ?
        _wordz[_lgg][_dmn] ?
          _wordz[_lgg][_dmn][_word] ?
            _fmt && _wordz[_lgg][_dmn][_word][_fmt] ?
              _wordz[_lgg][_dmn][_word][_fmt]
            : _wordz[_lgg][_dmn][_word]['fml'] ?
              _wordz[_lgg][_dmn][_word]['fml']
            : _wordz[_lgg][_dmn][_word]['aan'] ?
              _wordz[_lgg][_dmn][_word]['aan']
            : ''
          : ''
        : ''
      : '';

    if ( hf.f(_r) == false ) {
      _lgg = 'EN';
      _r = 
        _wordz[_lgg] ?
          _wordz[_lgg][_dmn] ?
            _wordz[_lgg][_dmn][_word] ?
              _fmt && _wordz[_lgg][_dmn][_word][_fmt] ?
                _wordz[_lgg][_dmn][_word][_fmt]
              : _wordz[_lgg][_dmn][_word]['fml'] ?
                _wordz[_lgg][_dmn][_word]['fml']
              : _wordz[_lgg][_dmn][_word]['aan'] ?
                _wordz[_lgg][_dmn][_word]['aan']
              : '-'
            : '-'
          : '-'
        : '-';
    }

    return _r;

  };
  return {
//    ..._dz,
    ... _gLggz,
    t: _t,
  }
}
